export function trafficArrayOfMaps(data) {
  var trafficArr = [];
  if (data !== null) {
    var length = data.length;
    for (var i = 0; i < length; i++) {
      // Then push our data to the new arrays
      var trafficMap = {};
      trafficMap["unique"] = data[i].trafficUnique;
      trafficMap["count"] = data[i].trafficCount;
      trafficMap["timestamps"] = data[i].metricTimeStamp;
      trafficArr.push(trafficMap);
    }
  }
  return trafficArr;
}

export function cloneArrayOfMaps(data) {
  var cloneArr = [];
  if (data !== null) {
    var length = data.length;
    for (var i = 0; i < length; i++) {
      // Then push our data to the new arrays
      var cloneMap = {};
      cloneMap["unique"] = data[i].cloneUnique;
      cloneMap["count"] = data[i].cloneCount;
      cloneMap["timestamps"] = data[i].metricTimeStamp;
      cloneArr.push(cloneMap);
    }
  }

  return cloneArr;
}

export function combinedArrayOfMaps(data) {
  var combinedArr = [];
  if (data !== null) {
    var length = data.length;
    for (var i = 0; i < length; i++) {
      // Then push our data to the new arrays
      var combinedMap = {};
      combinedMap["forkCount"] = data[i].forkCount;
      combinedMap["starCount"] = data[i].starCount;
      combinedMap["watcherCount"] = data[i].watcherCount;
      combinedMap["timestamps"] = data[i].metricTimeStamp;
      combinedArr.push(combinedMap);
    }
  }
  return combinedArr;
}

export function referrerArrayOfMaps(data) {
  var referrerArr = [];
  if (data !== null) {
    var length = data.length;
    for (var i = 0; i < length; i++) {
      // Then push our data to the new arrays
      var ref = data[i].referrer;
      var refArr = [];
      var referrerMap = {};

      if (ref !== null) {
        ref = JSON.parse(JSON.stringify(ref));

        for (var j = 0; j < ref.length; j++) {
          var refMap = {};
          refMap["count"] = ref[j].count;
          refMap["name"] = ref[j].name;
          refMap["uniques"] = ref[j].uniques;
          refArr.push(refMap);
        }

        referrerMap["timestamp"] = data[i].metricTimeStamp;
        referrerMap["referrers"] = refArr;
        referrerArr.push(referrerMap);
      }
    }
  }
  return referrerArr;
}

export function pathArrayOfMaps(data) {
  var pathArr = [];
  if (data !== null) {
    var length = data.length;
    for (var i = 0; i < length; i++) {
      // Then push our data to the new arrays
      var pth = data[i].path;
      var pthArr = [];
      var pathMap = {};

      if (pth !== null) {
        pth = JSON.parse(JSON.stringify(pth));
        for (var j = 0; j < pth.length; j++) {
          var pthMap = {};
          pthMap["count"] = pth[j].count;
          pthMap["path"] = pth[j].path;
          pthMap["title"] = pth[j].title;
          pthMap["uniques"] = pth[j].uniques;
          pthArr.push(pthMap);
        }

        pathMap["timestamp"] = data[i].metricTimeStamp;
        pathMap["paths"] = pthArr;
        pathArr.push(pathMap);
      }
    }
  }
  return pathArr;
}

export function rowColor(items) {
  items.forEach(function(obj) {
    if (obj.compliant === -1) {
      obj._rowVariant = "danger";
    } else if (obj.compliant === 0) {
      obj._rowVariant = "warning";
    }
  });
  return items;
}
